import * as React from "react";
import { useId } from "react-id-generator";
import { detect, convert, base64Encode, base64Decode } from "encoding-japanese";
import { toast } from "react-toastify";

type props = {
  file?: CsvFileType;
  setFile: (file: CsvFileType) => void;
};

export type CsvFileType = {
  name: string;
  data: string;
};

export const CsvUploader: React.FC<props> = ({ file, setFile }) => {
  const [id] = useId();
  return (
    <div className="field">
      <label htmlFor={id} className="label">
        CSVファイル
      </label>
      <div className="file has-name">
        <label className="file-label">
          <input
            className="file-input"
            type="file"
            id={id}
            name="csv-uploader"
            accept={"text/csv"}
            onChange={(e) => {
              const fileReader = new FileReader();
              const fileDropped = e.target.files![0];
              fileReader.onload = function () {
                // support both UTF-8 and Shift-JIS
                const dataUri = this.result as string;
                const rawTypeCsv = base64Decode(dataUri.split(",")[1]);
                const encoding = detect(rawTypeCsv, ["UTF8", "SJIS"]);
                if (!encoding) {
                  toast.error(
                    "選択したファイルに読み込めない文字が存在します。外字が含まれている場合はファイルの文字コードをUTF-8に変換してください。",
                  );
                  return;
                }
                const utf8ArrCsv = convert(rawTypeCsv, {
                  from: encoding ? encoding : undefined,
                  to: "UTF8",
                });
                setFile({
                  name: fileDropped.name,
                  data: base64Encode(utf8ArrCsv),
                });
              };
              fileReader.readAsDataURL(fileDropped);
            }}
          />
          <span className="file-cta">
            <span className="file-icon">
              <i className="fas fa-upload" />
            </span>
            <span className="file-label">
              {file?.name ? file.name : "ファイルを選択…"}
            </span>
          </span>
          <span className="file-name">{file ? "選択済み" : "未選択"}</span>
        </label>
      </div>
    </div>
  );
};
